import { IS_ALL_SSR } from 'dictionary';
import {
  BASIC_STEPS,
  ADVANCED_STEPS,
  RETURN_MODE_STEP,
  BASIC_STEPS_FEATURE_MAP,
  ADVANCED_STEPS_FEATURE_MAP
} from './stubs';

export function getSteps(isAdvancedMode = false, isAdvancedSupported = false) {
  const steps = IS_ALL_SSR && isAdvancedSupported ? [RETURN_MODE_STEP] : [];
  const isAdvanced = isAdvancedMode && isAdvancedSupported;
  const modeBasedSteps = isAdvanced ? ADVANCED_STEPS : BASIC_STEPS;
  steps.push(...modeBasedSteps);
  return steps;
}

export function getStepsFeatureMap(
  isAdvancedMode = false,
  isAdvancedSupported = false
) {
  const isAdvanced = isAdvancedMode && isAdvancedSupported;
  return isAdvanced ? ADVANCED_STEPS_FEATURE_MAP : BASIC_STEPS_FEATURE_MAP;
}

export function getVisibleSteps(
  isAdvancedMode = false,
  isAdvancedSupported = false
) {
  const steps = getSteps(isAdvancedMode, isAdvancedSupported);
  return steps.filter(step => !step.isHidden);
}
